(function(){
    const MOBILE_QUERY = '(max-width: 749px)';
  
    function getMobileItems(viewport){
      return Array.from(
        // Mobile should NOT include clone items (they exist only for desktop seamless looping)
        viewport.querySelectorAll('.mt-logo-text__group:not(.mt-logo-text__group--clone) .mt-logo-text__item')
      );
    }
  
    function scrollToIndex(viewport, items, index, behavior){
      if(!items.length) return;
      const i = Math.max(0, Math.min(index, items.length - 1));
      const item = items[i];
      const track = viewport.querySelector('[data-carousel-track]');
      const trackPaddingLeft = track ? parseInt(getComputedStyle(track).paddingLeft || '0', 10) : 0;
      
      let left;
      if(i === items.length - 1){
        const maxScroll = viewport.scrollWidth - viewport.clientWidth;
        left = Math.min(maxScroll, item.offsetLeft - trackPaddingLeft);
      } else {
        left = item.offsetLeft - trackPaddingLeft;
      }
      
      viewport.scrollTo({ left: Math.max(0, left), behavior: behavior || 'smooth' });
      return i;
    }
  
    function initMobileViewport(viewport){
      // Prevent duplicate event listeners when theme editor re-renders sections
      if(viewport.dataset.mtLogoTextMobileInit === '1') return;
      viewport.dataset.mtLogoTextMobileInit = '1';

      const controls = viewport.parentElement && viewport.parentElement.querySelector('[data-carousel-controls]');
      const prevBtn = controls && controls.querySelector('[data-carousel-prev]');
      const nextBtn = controls && controls.querySelector('[data-carousel-next]');
      const track = viewport.querySelector('[data-carousel-track]');
      if(!track) return;

      // Real items (indexing should always use real items, not clones)
      const realItems = getMobileItems(viewport);
      const n = realItems.length;
      if(n <= 0) return;
      if(controls) controls.style.display = n > 1 ? 'flex' : 'none';
      if(n <= 1) return;

      // Trailing clone group exists in Liquid. We will also ensure a leading clone group exists.
      const cloneCandidates = Array.from(
        viewport.querySelectorAll('.mt-logo-text__group--clone:not(.mt-logo-text__group--clone-before)')
      );
      const cloneAfterGroup = cloneCandidates[cloneCandidates.length - 1];
      if(!cloneAfterGroup) return;

      let cloneBeforeGroup = viewport.querySelector('.mt-logo-text__group--clone-before');
      if(!cloneBeforeGroup) {
        cloneBeforeGroup = cloneAfterGroup.cloneNode(true);
        cloneBeforeGroup.classList.add('mt-logo-text__group--clone-before');
        cloneBeforeGroup.setAttribute('aria-hidden', 'true');
        track.insertBefore(cloneBeforeGroup, track.firstElementChild);
      }

      const cloneBeforeItems = Array.from(cloneBeforeGroup.querySelectorAll('.mt-logo-text__item'));
      const cloneAfterItems = Array.from(cloneAfterGroup.querySelectorAll('.mt-logo-text__item'));

      // Triplet list for "closest item" detection (before + real + after)
      const allItems = [
        ...cloneBeforeItems.map((el, i) => ({ el, realIndex: i, kind: 'before' })),
        ...realItems.map((el, i) => ({ el, realIndex: i, kind: 'real' })),
        ...cloneAfterItems.map((el, i) => ({ el, realIndex: i, kind: 'after' })),
      ].filter(x => x.el);

      let index = 0; // real index 0..n-1

      const scrollToEl = (el, behavior) => {
        if(!el) return;
        viewport.scrollTo({ left: el.offsetLeft, behavior: behavior || 'smooth' });
      };

      const jumpToRealIndex = (i) => {
        index = (i + n) % n;
        scrollToEl(realItems[index], 'auto');
      };

      // Start at the first REAL item (after the leading clone)
      requestAnimationFrame(() => jumpToRealIndex(0));

      const findClosest = () => {
        const leftEdge = viewport.scrollLeft;
        let best = allItems[0];
        let bestDist = Infinity;
        for(const it of allItems) {
          const d = Math.abs(it.el.offsetLeft - leftEdge);
          if(d < bestDist) { bestDist = d; best = it; }
        }
        return best;
      };

      let scrollEndTimer;
      const onScrollEnd = () => {
        const closest = findClosest();
        if(!closest) return;
        index = closest.realIndex;
        // If user ended up on a clone, instantly jump to the matching real item (seamless loop)
        if(closest.kind === 'before' || closest.kind === 'after') {
          jumpToRealIndex(closest.realIndex);
        }
      };

      viewport.addEventListener('scroll', () => {
        clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(onScrollEnd, 120);
      }, { passive: true });

      // Buttons: scroll to adjacent item; if wrapping, scroll into clone (adjacent) then scrollEnd handler jumps
      if(prevBtn){
        prevBtn.addEventListener('click', () => {
          const targetIndex = (index - 1 + n) % n;
          if(index === 0 && cloneBeforeItems.length >= n) {
            scrollToEl(cloneBeforeItems[n - 1], 'smooth');
          } else {
            scrollToEl(realItems[targetIndex], 'smooth');
          }
          index = targetIndex;
        });
      }

      if(nextBtn){
        nextBtn.addEventListener('click', () => {
          const targetIndex = (index + 1) % n;
          if(index === n - 1 && cloneAfterItems.length) {
            scrollToEl(cloneAfterItems[0], 'smooth');
          } else {
            scrollToEl(realItems[targetIndex], 'smooth');
          }
          index = targetIndex;
        });
      }

      window.addEventListener('resize', () => {
        // Re-center on current real item after layout changes
        jumpToRealIndex(index);
      }, { passive: true });
    }
  
      function initClickMode(viewport){
        const track = viewport.querySelector('[data-carousel-track]');
        if(!track) return;

        const controls = viewport.parentElement && viewport.parentElement.querySelector('[data-carousel-controls]');
        const prevBtn = controls && controls.querySelector('[data-carousel-prev]');
        const nextBtn = controls && controls.querySelector('[data-carousel-next]');

        const originalItems = Array.from(
          viewport.querySelectorAll('.mt-logo-text__group:not(.mt-logo-text__group--clone) .mt-logo-text__item')
        );
        if(!originalItems.length) return;

        // Trailing clone group is rendered by Liquid (after originals)
        // NOTE: we also create a leading clone group in JS (`--clone-before`) which still has `--clone` class.
        // So we must pick the clone group that is NOT `--clone-before` (and ideally the last one).
        const cloneCandidates = Array.from(
          viewport.querySelectorAll('.mt-logo-text__group--clone:not(.mt-logo-text__group--clone-before)')
        );
        const cloneAfterGroup = cloneCandidates[cloneCandidates.length - 1];
        if(!cloneAfterGroup) return;

        // Create a leading clone group so `prev` from the first item can animate by 1 step seamlessly.
        // (Without this, the carousel has no content on the left side of the first item.)
        let cloneBeforeGroup = viewport.querySelector('.mt-logo-text__group--clone-before');
        if(!cloneBeforeGroup) {
          cloneBeforeGroup = cloneAfterGroup.cloneNode(true);
          cloneBeforeGroup.classList.add('mt-logo-text__group--clone-before');
          cloneBeforeGroup.setAttribute('aria-hidden', 'true');
          track.insertBefore(cloneBeforeGroup, track.firstElementChild);
        }

        const cloneBeforeItems = Array.from(cloneBeforeGroup.querySelectorAll('.mt-logo-text__item'));
        const cloneAfterItems = Array.from(cloneAfterGroup.querySelectorAll('.mt-logo-text__item'));

        const n = originalItems.length;
        if(controls) controls.style.display = n > 1 ? 'flex' : 'none';
        if(n <= 1) return;

        let currentIndex = 0; // 0..n-1 (originalItems)
        let isAnimating = false;

        const translateToItem = (el, animate = true) => {
          const x = el.offsetLeft;
          track.style.transition = animate ? 'transform 0.3s ease' : 'none';
          track.style.transform = `translate3d(${-x}px, 0, 0)`;
        };

        const jumpToOriginal = (index) => {
          currentIndex = (index + n) % n;
          translateToItem(originalItems[currentIndex], false);
        };

        // Initial position
        jumpToOriginal(0);

        const onPrev = () => {
          if(isAnimating) return;
          isAnimating = true;

          if(currentIndex === 0) {
            // Animate to the leading-clone last item (adjacent by 1 step), then jump to real last item.
            const target = cloneBeforeItems[cloneBeforeItems.length - 1];
            translateToItem(target, true);
            track.addEventListener('transitionend', () => {
              jumpToOriginal(n - 1);
              isAnimating = false;
            }, { once: true });
          } else {
            currentIndex -= 1;
            translateToItem(originalItems[currentIndex], true);
            track.addEventListener('transitionend', () => { isAnimating = false; }, { once: true });
          }
        };

        const onNext = () => {
          if(isAnimating) return;
          isAnimating = true;

          if(currentIndex === n - 1) {
            // Animate to the trailing-clone first item (adjacent by 1 step), then jump to real first item.
            const target = cloneAfterItems[0];
            translateToItem(target, true);
            track.addEventListener('transitionend', () => {
              jumpToOriginal(0);
              isAnimating = false;
            }, { once: true });
          } else {
            currentIndex += 1;
            translateToItem(originalItems[currentIndex], true);
            track.addEventListener('transitionend', () => { isAnimating = false; }, { once: true });
          }
        };

        if(prevBtn) prevBtn.addEventListener('click', onPrev);
        if(nextBtn) nextBtn.addEventListener('click', onNext);

        // After images load / resize, offsetLeft can change.
        const relayout = () => jumpToOriginal(currentIndex);
        const imgs = viewport.querySelectorAll('img');
        imgs.forEach((img) => {
          img.addEventListener('load', relayout, { once: true });
          img.addEventListener('error', relayout, { once: true });
        });
        window.addEventListener('resize', relayout, { passive: true });

        // Disable drag in click mode
        viewport.style.cursor = 'default';
        viewport.style.userSelect = 'auto';
        viewport.addEventListener('mousedown', (e) => e.preventDefault());
        viewport.addEventListener('touchstart', (e) => e.preventDefault());
      }
  
    function initViewport(viewport){
      const track = viewport.querySelector('[data-carousel-track]');
      if(!track) return;
  
      // Mobile uses native scrolling
      if(window.matchMedia && window.matchMedia(MOBILE_QUERY).matches){
        initMobileViewport(viewport);
        return;
      }
  
      // Desktop: click mode with infinite loop
      initClickMode(viewport);
    }
  
    document.addEventListener('DOMContentLoaded', function(){
      document.querySelectorAll('.mt-logo-text [data-carousel-viewport]').forEach(initViewport);
    });
  })();
  